import { render, staticRenderFns } from "./MyPo.vue?vue&type=template&id=64538ba5&scoped=true&"
import script from "./MyPo.vue?vue&type=script&lang=js&"
export * from "./MyPo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64538ba5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64538ba5')) {
      api.createRecord('64538ba5', component.options)
    } else {
      api.reload('64538ba5', component.options)
    }
    module.hot.accept("./MyPo.vue?vue&type=template&id=64538ba5&scoped=true&", function () {
      api.rerender('64538ba5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mypo/MyPo.vue"
export default component.exports